<template>
  <div id="page-user-list">
    <div class="vx-card p-6">
      <div class="flex flex-wrap items-center">
        <!-- ITEMS PER PAGE -->
        <vs-popup classContent="popup-example" title="Manage Promotion" :active.sync="popup">
          <template>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input class="w-full" label="ชื่อโปรโมชั่น" v-model="promotion.name" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                  <vs-select v-model="promotion.type" class="w-full select-large" label="ประเภท">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in typeOptions" class="w-full" />
                  </vs-select>
                </div>
            </div>
            <div class="vx-row" v-if="promotion.typebonus!=='%'">
                <div class="vx-col sm:w-1/2 w-full mb-2" v-if="promotion.type !== 'ฝากต่อเนื่อง'">
                  <vs-select v-model="promotion.typebonus" class="w-full select-large" label="ประเภทโบนัส">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in typebonusOptions" class="w-full" />
                  </vs-select>
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2" v-else>
                    <vs-input class="w-full" label="จำนวนวัน" v-model="promotion.numday" @keypress="isNumberOnly($event)" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2">
                    <vs-input class="w-full" :label="(promotion.type !== 'ฝากต่อเนื่อง')?'โบนัสสูงสุด':'โบนัส'" v-model="promotion.maxbonus" @keypress="isNumber($event)"/>
                </div>
            </div>
            <div class="vx-row" v-if="promotion.typebonus==='%'">
                <div class="vx-col sm:w-1/3 w-full mb-3" v-if="promotion.type !== 'ฝากต่อเนื่อง'">
                  <vs-select v-model="promotion.typebonus" class="w-full select-large" label="ประเภทโบนัส">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in typebonusOptions" class="w-full" />
                  </vs-select>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input class="w-full" label="จำนวน %" v-model="promotion.percent" @keypress="isNumber($event)"/>
                </div>
                <div class="vx-col sm:w-1/3 w-full mb-3">
                    <vs-input class="w-full" :label="(promotion.type !== 'ฝากต่อเนื่อง')?'โบนัสสูงสุด':'โบนัส'" v-model="promotion.maxbonus" @keypress="isNumber($event)"/>
                </div>
            </div>
            <div class="vx-row">
                <div :class="(promotion.type !== 'ฝากต่อเนื่อง')?'vx-col sm:w-1/2 w-full mb-2':'vx-col sm:w-2/2 w-full mb-2'">
                    <vs-input class="w-full" :label="(promotion.type !== 'ฝากต่อเนื่อง')?'ฝากต่ำสุด':'ฝากขั้นต่ำ/วัน'" @keypress="isNumber($event)" v-model="promotion.mindeposit" />
                </div>
                <div class="vx-col sm:w-1/2 w-full mb-2" v-if="promotion.type !== 'ฝากต่อเนื่อง'">
                    <vs-input class="w-full" label="ฝากสูงสุด" v-model="promotion.maxdeposit" @keypress="isNumber($event)" />
                </div>
            </div>
            <div class="vx-row" v-if="promotion.type==='ฝากทั้งวัน' || promotion.type==='โปรช่วงเวลา' || promotion.type==='โปรพิเศษ'">
                <div class="vx-col sm:w-3/3 w-full" v-if="promotion.type==='ฝากทั้งวัน' || promotion.type==='โปรช่วงเวลา' || promotion.type==='โปรพิเศษ'">
                    <vs-input class="w-full" label="จำนวนครั้งในการรับโปรต่อวัน 0=ไม่จำกัด" v-model="promotion.maxreceive" @keypress="isNumberOnly($event)" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-input class="w-full" label="จำนวนยอดถอนสูงสุดกี่เท่า" v-model="promotion.maxwithdraw" @keypress="isNumber($event)" />
                </div>
                <div class="vx-col sm:w-1/2 w-full" v-if="promotion.type!=='ฝากต่อเนื่อง'">
                    <vs-select v-model="promotion.withdrawtype" class="w-full select-large" label="จำนวนยอดถอนสูงสุดกี่เท่าของยอด">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in withdrawtypeOptions" class="w-full" />
                  </vs-select>
                </div>
                <div class="vx-col sm:w-1/2 w-full" v-else>
                    <vs-select v-model="promotion.withdrawtype" class="w-full select-large" label="จำนวนยอดถอนสูงสุดกี่เท่าของยอด">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in withdrawtypeOptionsDaily" class="w-full" />
                  </vs-select>
                </div>
            </div>
            <div class="vx-row" v-if="promotion.type=='โปรช่วงเวลา' || promotion.type=='โปรพิเศษ'">
                <div class="mt-4 vx-col sm:w-1/2 w-full mb-2">
                    <label class="text-sm">Start time : </label>
                    <flat-pickr :config="configdateTimePicker" v-model="promotion.starttime" label="Choose time" />
                </div>
                <div class="mt-4 vx-col sm:w-1/2 w-full mb-2">
                    <label class="text-sm">End time : </label>
                    <flat-pickr :config="configdateTimePicker" v-model="promotion.endtime" label="Choose time" />
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full">
                    <vs-input class="w-full" label="จำนวนยอดเครดิตกี่เท่า" v-model="promotion.turn" @keypress="isNumberOnly($event)" />
                </div>
                <div class="vx-col sm:w-1/2 w-full" v-if="promotion.type!=='ฝากต่อเนื่อง'">
                    <vs-select v-model="promotion.turntype" class="w-full select-large" label="คิดยอดเครดิตจาก">
                      <!-- <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in turnTypeOptions" class="w-full" /> -->
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in withdrawtypeOptions" class="w-full" />
                    </vs-select>
                </div>
                <div class="vx-col sm:w-1/2 w-full" v-else>
                    <vs-select v-model="promotion.turntype" class="w-full select-large" label="คิดยอดเครดิตจาก">
                      <!-- <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in turnTypeOptions" class="w-full" /> -->
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in withdrawtypeOptionsDaily" class="w-full" />
                    </vs-select>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col sm:w-1/2 w-full" style="padding-top: 15px;">
                    <label class="text-sm">สถานะ</label>
                    <vs-switch v-model="promotion.status" />
                </div>
            </div>
            <template v-if="promotion.typebonus ==='ค่าคงที่'"><br><hr><br></template>
            
            <div v-for="(item,index) in promotion.setbonus" :key="index" class="vx-row" v-if="promotion.typebonus ==='ค่าคงที่'">
                <div class="vx-col sm:w-1/4 w-full">
                    <vs-input class="w-full" label="ต่ำสุด" v-model="promotion.setbonus[index].min" @keypress="isNumberOnly($event)" />
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                    <vs-input class="w-full" label="สูงสุด" v-model="promotion.setbonus[index].max" @keypress="isNumberOnly($event)" />
                </div>
                <div class="vx-col sm:w-1/4 w-full">
                    <vs-input class="w-full" label="โบนัส" v-model="promotion.setbonus[index].bonus" @keypress="isNumberOnly($event)" />
                </div>
                <div class="vx-col sm:w-1/4 w-full" style="padding-top: 17px;">
                  <vs-button color="danger" type="border" @click="deleteRow(index)">ลบ</vs-button>
                </div>
            </div>
            <div class="vx-row" v-if="promotion.typebonus ==='ค่าคงที่'">
              <div class="vx-col w-full" style="text-align:center;padding-top:10px;">
                <vs-button color="success" type="border" @click="addRow()">เพิ่ม</vs-button>
              </div>
            </div>
          </template>
          <br>
          <vs-button color="primary" type="filled" @click="updateUser">Save</vs-button>&nbsp;&nbsp;&nbsp;
          <vs-button color="dark" type="filled" @click="closePopup">Close</vs-button>
        </vs-popup>
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
              <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
          <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
          <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown vs-trigger-click class="cursor-pointer">

            <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
              <span class="mr-2 leading-none">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
           <vs-dropdown-menu>
              <vs-dropdown-item @click="Add()">
                <span class="flex items-center">
                  <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Add</span>
                </span>
              </vs-dropdown-item>

              <!--vs-dropdown-item @click="Delete()">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </!--vs-dropdown-item-->

              <!--vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Archive</span>
                </span>
              </!--vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Print</span>
                </span>
              </vs-dropdown-item>

              <vs-dropdown-item>
                <span class="flex items-center">
                  <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>CSV</span>
                </span>
              </vs-dropdown-item>-->

            </vs-dropdown-menu>
          </vs-dropdown>
      </div>


      <!-- AgGrid Table floatingFilter="true"-->
      <!--:onGridReady="onGridReady" -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="usersData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
        >
      </ag-grid-vue>
      <vs-pagination
        :total="totalPages"
        :max="7"
        v-model="currentPage" />

    </div>
  </div>

</template>

<script>
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import vSelect from 'vue-select'
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
// Store Module
const axios = require('axios').default;
// Cell Renderer
import CellRendererLink from './cell-renderer/CellRendererLink.vue'
import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
import CellRendererActions from './cell-renderer/CellRendererActions.vue'
import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'
import CellRendererBank from './cell-renderer/CellRendererBank.vue'
import moment from "moment-timezone";
import firebase from '@/services/saleData'
import 'firebase/database'
import 'firebase/firestore'
import { createHelpers } from 'vuex-map-fields'
const { mapFields } = createHelpers({
  getterType: `promotionManagement/getField`,
  mutationType: `promotionManagement/updateField`,
});
export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions,
    CellRendererCreateDate,
    CellRendererBank
  },
  data () {
    return {
        setBonus:[],
        configdateTimePicker: {
            enableTime: true,
            enableSeconds: false,
            noCalendar: true,
            time_24hr: true
        },
        typebonusOptions: [
            {text: "ค่าคงที่", value:"ค่าคงที่"},
            {text: "%", value:"%"},
        ],
        withdrawtypeOptions:[
            {text: "ยอดฝาก", value:"ยอดฝาก"},
            {text: "ยอดฝากรวมโบนัส", value:"ยอดฝากรวมโบนัส"},
        ],
        withdrawtypeOptionsDaily:[
            {text: "ยอดโบนัส", value:"ยอดโบนัส"},
        ],
        typeOptions: [
            {text: "สมัครสมาชิกใหม่", value:"สมัครสมาชิกใหม่"},
            {text: "โปรพิเศษ", value:"โปรพิเศษ"},
            {text: "ฝากแรกของวัน", value:"ฝากแรกของวัน"},
            {text: "โปรช่วงเวลา", value:"โปรช่วงเวลา"},
            {text: "ฝากทั้งวัน", value:"ฝากทั้งวัน"},
            {text: "ฝากต่อเนื่อง", value:"ฝากต่อเนื่อง"},
            
        ],
        turnTypeOptions: [
            {text: "Turnover", value:"Turnover"},
            {text: "Balance", value:"Balance"},
        ],
      userId:'',
      selected: '',
      selectedmenu: '',
      adminsend:'',
      // Filter Options
      roleFilter: { label: 'All', value: 'all' },
      roleOptions: [
        { label: 'All', value: 'all' },
        { label: 'Admin', value: 'admin' },
        { label: 'User', value: 'user' },
        { label: 'Staff', value: 'staff' }
      ],

      statusFilter: { label: 'All', value: 'all' },
      statusOptions: [
        { label: 'All', value: 'all' },
        { label: 'Active', value: 'active' },
        { label: 'Deactivated', value: 'deactivated' },
        { label: 'Blocked', value: 'blocked' }
      ],

      isVerifiedFilter: { label: 'All', value: 'all' },
      isVerifiedOptions: [
        { label: 'All', value: 'all' },
        { label: 'Yes', value: 'yes' },
        { label: 'No', value: 'no' }
      ],

      departmentFilter: { label: 'All', value: 'all' },
      departmentOptions: [
        { label: 'All', value: 'all' },
        { label: 'Sales', value: 'sales' },
        { label: 'Development', value: 'development' },
        { label: 'Management', value: 'management' }
      ],

      searchQuery: '',

      // AgGrid
      gridApi: null,
      gridOptions: {
        rowHeight: 100,
        suppressContextMenu:true,
      },
      defaultColDef: {
        sortable: true,
        editable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: 'ชื่อ',
          field: 'name',
          width: 250,
          filter: true,
        },
        {
          headerName: 'ประเภท',
          field: 'type',
          filter: true,
          width: 150
        },
        {
          headerName: 'ประเภทโบนัส',
          field: 'typebonus',
          filter: true,
          width: 100
        },
        {
          headerName: 'โบนัสสูงสุด',
          field: 'maxbonus',
          filter: true,
          width: 100,
          cellRendererFramework: 'CellRendererBank'
        },
        {
          headerName: 'ฝากต่ำสุด',
          field: 'mindeposit',
          filter: true,
          width: 100
        },
        {
          headerName: 'ฝากสูงสุด',
          field: 'maxdeposit',
          filter: true,
          width: 100
        },
        {
          headerName: 'จำนวนยอดถอนสูงสุดกี่เท่า',
          field: 'maxwithdraw',
          filter: true,
          width: 150
        },
        {
          headerName: 'Create Date',
          field: 'createdate',
          filter: true,
          width: 200,
          cellRendererFramework: 'CellRendererCreateDate'
        },
        {
          headerName: 'สถานะ',
          field: 'status',
          filter: true,
          width: 65,
          cellRendererFramework: 'CellRendererStatus'
        },
        {
          headerName: 'Actions',
          field: 'transactions',
          width: 80,
          cellRendererFramework: 'CellRendererActions'
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererCreateDate,
        CellRendererBank,
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    }
  },
  watch: {
    roleFilter (obj) {
      this.setColumnFilter('role', obj.value)
    },
    statusFilter (obj) {
      this.setColumnFilter('status', obj.value)
    },
    departmentFilter (obj) {
      this.setColumnFilter('department', obj.value)
    }
  },
  computed: {
    ...mapFields([
        'popup',
        'popup2',
        'promotion',
        'promotion.image',
    ]),
    usersData () {
      return this.$store.state.promotionManagement.promotions
    },
    paginationPageSize () {
      //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
      return 100
    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
    userLogin(){
      return this.$store.state.AppActiveUser
    },
    currentPage: {
      get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }
    }
  },
  methods: {
    addRow(){
      this.promotion.setbonus.push({
        min:0,max:0,bonus:0,
      });
    },
    previewImage(event) {
      this.imageData = event.target.files[0];
      this.promotion.image = URL.createObjectURL(this.imageData);
      //this.onUpload()
    },
    isNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    isNumberOnly(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
    onGridReady(params){
        this.gridApi = params.api;
        this.columnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();
        window.onresize = () => {
            this.gridApi.sizeColumnsToFit();
        }
    },
    confirmDeleteRecord (data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: `You are about to delete "${data}"`,
        accept: this.deleteRecord,
        acceptText: 'Delete'
      })
    },
    async deleteRecord () {
      for(const data of this.gridApi.getSelectedRows()){
        const emailKey = data.email.trim().replace(/\./g, '||');
        await firebase.database().ref().child(`users/${emailKey}`).remove();
      }
      this.showDeleteSuccess()
      this.$store.dispatch('userManagement/fetchUsers').catch(err => { console.error(err) })
    },
    showDeleteSuccess () {
      this.$vs.notify({
        color: 'success',
        title: 'User Deleted',
        text: 'The selected user was successfully deleted'
      })
    },
    Add(){
      this.$store.commit('promotionManagement/SET_PROMOTION', {
        name:'',
        id:'',
        type:'',
        typebonus:'',
        maxbonus:'',
        mindeposit:'',
        maxdeposit:'',
        maxwithdraw:'',
        starttime:'',
        endtime:'',
        status:false,
        show:false,
        createdate:'',
        numday:0,
        maxreceive:0,
        turn:0,
        percent:0,
        withdrawtype:'',
        turntype:'',
        image:'',
        setbonus:[],
      });
      this.$store.commit('promotionManagement/SET_POPUP',true);
    },
    Delete(){
      if(this.gridApi.getSelectedRows().length){
        let text = ''
        for(const data of this.gridApi.getSelectedRows()){
          text += (text)?', '+data.firstname:data.firstname
        }
        this.confirmDeleteRecord(text);
      }
    },
    setColumnFilter (column, val) {
      const filter = this.gridApi.getFilterInstance(column)
      let modelObj = null

      if (val !== 'all') {
        modelObj = { type: 'equals', filter: val }
      }

      filter.setModel(modelObj)
      this.gridApi.onFilterChanged()
    },
    resetColFilters () {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null)
      this.gridApi.onFilterChanged()

      // Reset Filter Options
      this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }

      this.$refs.filterCard.removeRefreshAnimation()
    },
    updateSearchQuery (val) {
      this.gridApi.setQuickFilter(val)
    },
    async updateUser(){
      if(this.promotion.id){
        const promotion = this.promotion;
        promotion.updatedate = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
        promotion.employee = this.userLogin;
        if(promotion.numday) promotion.numday = Number(promotion.numday);
        if(promotion.order) promotion.order = Number(promotion.order);
        await firebase.firestore().collection('promotions').doc(this.promotion.id).update(promotion).then(()=>{
          this.$store.dispatch('promotionManagement/fetchPromotions').catch(err => { console.error(err) })
            this.$vs.notify({
                color: 'success',
                title: 'Update Promotion',
                text: 'The selected promotion was successfully'
            })
        }).then(()=>{
          this.saveImage(this.promotion.id);
        });
      }else{
        const promotion = this.promotion;
        promotion.updatedate = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
        promotion.createdate = moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss");
        if(promotion.numday) promotion.numday = Number(promotion.numday);
        if(promotion.order) promotion.order = Number(promotion.order);
        promotion.employee = this.userLogin;
        await firebase.firestore().collection('promotions').add(promotion).then((result)=>{
          this.saveImage(result.id);
          this.$store.dispatch('promotionManagement/fetchPromotions').catch(err => { console.error(err) })
          this.$vs.notify({
              color: 'success',
              title: 'Created Promotion',
              text: 'The selected promotion was successfully'
          })
        });
      }
      /*.then(async response => {
       
      }).catch(function() {
        
      });*/
      this.$store.commit('promotionManagement/SET_PROMOTION', {
        name:'',
        id:'',
        type:'',
        typebonus:'',
        maxbonus:'',
        mindeposit:'',
        maxdeposit:'',
        maxwithdraw:'',
        starttime:'',
        endtime:'',
        status:false,
        show:false,
        order:0,
        createdate:'',
        numday:0,
        maxreceive:0,
        turn:0,
        percent:0,
        withdrawtype:'',
        turntype:'',
        image:'',
        setbonus:[],
      });
      this.$store.commit('promotionManagement/SET_POPUP', false);
    },
    async saveImage(id){
      if(this.promotion.image !== '' && this.imageData){
        const imagetype = this.imageData.name.split('.');
        const storageRef = firebase.storage().ref(`images/promotions/${id}.${imagetype[imagetype.length-1]}`).put(this.imageData);
        storageRef.on(`state_changed`,snapshot=>{
            this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
          }, error=>{console.log(error.message)},
        ()=>{
            storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                firebase.firestore().collection('promotions').doc(id).update({
                  image:url,
                })
            });
        });
      }
    },
    async updateUser2(){
      if(this.userSelect2 && this.userId.userId){
        const users2 = (await firebase.database().ref(`users`).orderByChild('userId').equalTo(this.userId.userId).once('value')).val();
        const key = Object.keys(users2)[0];
        firebase.firestore().collection('friends').doc(this.userId.userId).set({
          createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
          userId:this.userSelect2.userId,
          friendId:this.userId.userId,
        });
        firebase.database().ref(`users/${key}`).update({
          userFriendId:this.userSelect2.userId
        }).then(()=>{
          this.$vs.notify({
            color: 'success',
            title: 'Add Friend',
            text: 'The selected user was successfully'
          })
        });
      }
      firebase.firestore().collection("sharefriend").add({
        userId:this.userSelect2.userId,
        friendId:this.userId.userId,
        createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss")
      }).then((query)=>{
        axios({
          method: "get",
          url: "https://api.trueslot.bet/sharefriend/"+query.id,
        });
      });
       this.$store.commit('userManagement/SET_POPUP2', false);
    },
    closePopup(){
       this.$store.commit('promotionManagement/SET_POPUP', false);
    },
  },
  mounted () {
    this.gridApi = this.gridOptions.api
    if(window.innerWidth>1000)
    setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
      header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
    }
  },
  created () {
    this.$store.dispatch('promotionManagement/fetchPromotions').catch(err => { console.error(err) })
  }
}

</script>
<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>
